export const INSURANCE_POLICY_KINDS = {
  HOMEOWNERS: 'homeowners',
  COOP: 'coop',
  FLOOD: 'flood',
  CONDO: 'condo',
  OTHER: 'other',
};
